import { FormatAlignJustify, Grading } from "@mui/icons-material";
import { Autocomplete, Box, Checkbox, IconButton, TextField, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { MRT_Localization_RU } from 'material-react-table/locales/ru';
import React from "react";
import { initialValues } from "../../../constants";

const EmployeeLogBook = ({
    currentLesson, logBook, students, tasks, isLoading,
    onUpdateLogBook, onOpenTaskForm, onViewAnswer,
}) => {

    const getIsViewAnswerDisabled = task => !task.id || !task.answer_text || task.answer_text === ""

    const data = React.useMemo(() => !currentLesson ? [] : students.map(student => {
        const logBookItem = logBook.find(lgi => lgi.student === student.id)
        const task = tasks.find(el => el.student === student.id) ?? { ...initialValues.task, student: student.id, lesson: currentLesson.id }
        return logBookItem ? ({
            ...logBookItem,
            student_name: `${student.surname} ${student.name} ${student?.patronymic ?? ""}`,
            task
        }) : ({
            ...initialValues.logBookItem,
            lesson: currentLesson.id,
            student: student.id,
            student_name: `${student.surname} ${student.name} ${student?.patronymic ?? ""}`,
            task
        })
    }), [currentLesson, students, logBook, tasks])

    const table = useMaterialReactTable({
        data,
        state: { isSaving: isLoading, density: "compact", },
        enablePagination: false,
        localization: MRT_Localization_RU,
        columns: [
            { id: "student_name", accessorKey: "student_name", header: "ФИО", size: 200 },
            {
                id: "value",
                accessorKey: "value",
                header: "Оценка",
                size: 110,
                maxSize: 110,
                grow: false,
                Cell: ({ row, cell }) => <Autocomplete
                    size="small"
                    variant="standard"
                    value={cell.getValue() ?? null}
                    options={["2", "3", "4", "5", "Н", "К"]}
                    getOptionLabel={option => `${option}`}
                    slotProps={{
                        clearIndicator: { size: "small", sx: { width: 18, height: 18 } },
                        popupIndicator: { size: "small", sx: { width: 18, height: 18, ml: 0.5 } }
                    }}
                    // disabled={isLoading}
                    onChange={(_, value) => onUpdateLogBook({
                        ...row.original,
                        value: value === "" ? null : value,
                        mark: ["Н", "К"].includes(value) ? null : value,
                    })}
                    sx={{ minWidth: 90, maxWidth: 90 }}
                    renderInput={props => <TextField {...props} />}
                />
            },
            // {
            //     id: "is_absent",
            //     accessorFn: data => !data.is_absent,
            //     header: "Явка",
            //     size: 53,
            //     maxSize: 53,
            //     grow: false,
            //     Cell: ({ row, cell }) => <Checkbox
            //         size="small"
            //         checked={cell.getValue()}
            //         // disabled={isLoading}
            //         onChange={(_, value) => onUpdateLogBook({
            //             ...row.original,
            //             is_absent: !value,
            //             value: !value ? "Н" : row.original.value,
            //             mark: null,
            //         })}
            //     />,
            // },
            { id: "task.name", accessorKey: "task.name", header: "Задание", size: 200 },
        ],
        layoutMode: "grid",
        editDisplayMode: "cell",
        enableColumnFilters: false,
        enableRowActions: true,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        enableSorting: false,
        enableHiding: false,
        enableStickyHeader: true,
        enableColumnActions: false,
        positionActionsColumn: "last",
        renderRowActions: ({ row }) => <Box sx={{ display: "flex", gapX: 1 }}>
            <Tooltip title={row.original.task.id ? "Редактировать задание" : "Добавить задание"}>
                <IconButton onClick={() => onOpenTaskForm(row.original.task)}>
                    <FormatAlignJustify color="primary" />
                </IconButton>
            </Tooltip>

            <Tooltip title="Просмотреть ответ на задание"><span>
                <IconButton
                    onClick={() => onViewAnswer(row.original)}
                    disabled={getIsViewAnswerDisabled(row.original?.task)}
                >
                    <Grading color={getIsViewAnswerDisabled(row.original?.task) ? "disabled" : "primary"} />
                </IconButton>
            </span></Tooltip>
        </Box>,
        mrtTheme: { baseBackgroundColor: "#FFF" },
        defaultColumn: { muiTableBodyCellProps: { sx: { py: 0 } } },
        muiTableContainerProps: {
            sx: {
                minHeight: "calc(100% - 56px)",
                maxHeight: "calc(100% - 56px)",
                bgcolor: "white"
            },
        },
        muiTablePaperProps: { sx: { width: "100%", height: "100%", zIndex: 2 } },

    })

    if (!currentLesson) return null

    return <Box sx={{ height: "100%", width: "100%", display: "flex", flexDirection: "column" }}>

        <MaterialReactTable table={table} />

    </Box>
}

export default EmployeeLogBook